'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../layout/slick');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).ready(function () {
    (0, _jquery2.default)('.slider-process-img').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev pull-left"><svg width="21" height="35" viewBox="0 0 21 35"><g><g><path fill="none" stroke="#00ab84" stroke-miterlimit="20" stroke-width="4" d="M18.786 1.304v0L2.922 17.168v0l15.864 15.864v0"/></g></g></svg></button>',
        nextArrow: '<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="35" viewBox="0 0 21 35"><g><g><path fill="none" stroke="#00ab84" stroke-miterlimit="20" stroke-width="4" d="M1.999 33.032v0l15.864-15.864v0L2 1.304v0"/></g></g></svg></button>',
        dots: true,
        dotsClass: 'dots-process',
        fade: true,
        asNavFor: '.slider-process-text'
    });
    (0, _jquery2.default)('.slider-process-text').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.slider-process-img',
        dots: false,
        arrows: false,
        adaptiveHeight: true,
        fade: true,
        centerMode: true,
        focusOnSelect: true
    });
});